import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type OrderError = {
  errors: {
    connectivity: string[] | null;
    insufficientFunds: string[] | null;
    achInsufficientFunds: string[] | null;
    cardDeclined: string[] | null;
    achDeclined: string[] | null;
    gatewayError: string[] | null;
    account: string[] | null;
    order: string[] | null;
    taxId: string[] | null;
  };
};

type Error = {
  data: any | null;
  place: string;
};

export type InitState = {
  error: Error;
};

export const initialState = {
  error: {
    data: null,
    place: ''
  }
} as InitState;

const slice = createSlice({
  name: 'errorCatcher',
  initialState,
  reducers: {
    errorCatch: (state, action: PayloadAction<Error>) => {
      state.error = action.payload;
    },
    cleanError: state => {
      state.error.data = null;
      state.error.place = '';
    }
  }
});

export const { errorCatch, cleanError } = slice.actions;
export default slice.reducer;
